/* eslint-disable react/prop-types */
import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import toastr from 'toastr';
import { ModalProvider } from 'styled-react-modal';

import messagesTr from './translations/tr.json';
import messagesEn from './translations/en.json';

import { trackException, trackEvent, trackTrace } from './helpers/insights';
import TelemetryProvider from './helpers/telemetry-provider';
import { getAppInsights } from './helpers/TelemetryService';

import Routes from './routes';

const messages = {
  tr: messagesTr,
  en: messagesEn,
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    const { history } = this.props;

    history.listen(() => {
      toastr.remove();
    });

    this.appInsights = null;
  }

  render() {
    const { history, context, lang } = this.props;

    return (
      <TelemetryProvider instrumentationKey="ffed2ad6-f4ca-403a-b099-15d82df0241f" after={() => { this.appInsights = getAppInsights(); }}>
        <IntlProvider locale={lang.lang} messages={messages[lang.lang]}>
          <ConnectedRouter history={history} context={context}>
            <ModalProvider>
              <Routes />
            </ModalProvider>
          </ConnectedRouter>
        </IntlProvider>
      </TelemetryProvider>
    );
  }
}

function mapStateToProps(state, dispatch) {
  const {
    alert, lang, auth,
  } = state;
  return {
    alert,
    lang,
    dispatch,
    user: auth.user,
  };
}
export default connect(mapStateToProps)(App);
